import React, { FC } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { StyledQuickAccessContainer, StyledQuickAccessItem, customScrollbarCss, styles } from './QuickAccess.styles';

export interface QuickAccessProps {
  list: { name: string; disabled: boolean }[];
  selectedItem: string;
  onSelect: (item: string) => void;
  refEl: React.RefObject<HTMLDivElement>;
}

export const QuickAccess: FC<QuickAccessProps> = props => {
  const { list, selectedItem, onSelect, refEl } = props;

  return (
    <Flex justifyContent="center" maxWidth={{ _: 'calc(100vw - 48px)', sm2: 'calc(100vw - 176px)' }}>
      <StyledQuickAccessContainer __css={styles.quickAccessContainer} overflowX="auto" css={customScrollbarCss} ref={refEl}>
        {list.map(alphabet => (
          <StyledQuickAccessItem
            key={alphabet.name}
            id={`quickAccess-${alphabet.name}`}
            __css={styles.quickAccessItem(selectedItem === alphabet.name, alphabet.disabled)}
            onClick={() => onSelect(alphabet.name)}
          >
            <TextV2 typographyVariant="hed4" whiteSpace="nowrap">
              {alphabet.name}
            </TextV2>
          </StyledQuickAccessItem>
        ))}
      </StyledQuickAccessContainer>
    </Flex>
  );
};
